import * as j from '@mojotech/json-type-validation';

export const FilterType = {
  Active: 'active',
  Inactive: 'inactive',
} as const;

export type FilterType = typeof FilterType[keyof typeof FilterType];

export type CreateCampaignLeadList = {
  name: string;
  description: string;
  priority: number;
  startTime?: string;
  endTime?: string;
};

export type CampaignLeadList = {
  id: number;
  name: string;
  isActive: boolean;
  priority: number;
  totalLeads: number;
  numCompleted: number;
  isDefaultList: boolean;
};

export interface CampaignLeadListResponse {
  nextPageUrl: string | null;
  list: CampaignLeadList[];
}

const CampaignLeadListItemResponseDecoder: j.Decoder<CampaignLeadList> = j
  .object({
    id: j.number(),
    name: j.string(),
    is_active: j.boolean(),
    priority: j.number(),
    total_leads: j.number(),
    num_completed: j.number(),
    is_default_list: j.boolean(),
  })
  .map((item: any) => ({
    id: item.id,
    name: item.name,
    isActive: item.is_active,
    priority: item.priority,
    totalLeads: item.total_leads,
    numCompleted: item.num_completed,
    isDefaultList: item.is_default_list,
  }));

export const CampaignLeadListResponseDecoder: j.Decoder<CampaignLeadListResponse> = j
  .object({
    next_page_url: j.union(j.string(), j.constant(null)),
    list: j.array(CampaignLeadListItemResponseDecoder),
  })
  .map((item: any) => ({
    nextPageUrl: item.next_page_url,
    list: item.list,
  }));
